var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m.618 2.953.017-.016L3.109.957a.4.4 0 0 1 .296-.085q.165.018.27.15.104.13.086.296a.4.4 0 0 1-.15.27L2.052 2.835h4.3q1.305 0 2.226.921.922.925.922 2.228 0 1.305-.922 2.226a3.03 3.03 0 0 1-2.225.922H2.625a.39.39 0 0 1-.285-.119.39.39 0 0 1-.119-.284q0-.168.119-.285a.39.39 0 0 1 .285-.118h3.728q.97 0 1.655-.686a2.26 2.26 0 0 0 .686-1.656q0-.97-.686-1.658a2.26 2.26 0 0 0-1.655-.685H2.045l1.651 1.333q.129.105.147.271a.39.39 0 0 1-.087.295.4.4 0 0 1-.27.149.4.4 0 0 1-.297-.087L.65 3.552a.4.4 0 0 1-.12-.162l-.005-.012-.002-.007-.006-.019A.4.4 0 0 1 .5 3.24l.001-.034q0-.006.002-.012l.012-.064a.3.3 0 0 1 .028-.073l.022-.038a.4.4 0 0 1 .053-.065",
    clipRule: "evenodd"
  })));
};
export default SvgReturn;